module.exports = __webpack_public_path__ + "static/media/slider_img3.54da9185.jpg";